"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertArrayOfObjectsToCSV = void 0;

var _appendElement = require("../helpers/append-element");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var convertArrayOfObjectsToCSV = function convertArrayOfObjectsToCSV(data, _ref) {
  var header = _ref.header,
      separator = _ref.separator;

  var array = _toConsumableArray(data);

  var csv = '';

  if (header) {
    header.forEach(function (headerEl, i) {
      var thisHeaderEl = headerEl || (headerEl === 0 ? 0 : '');
      csv += (0, _appendElement.appendElement)(thisHeaderEl, header.length, i, separator);
    });
  }

  array.forEach(function (row, idx) {
    var thisRow = Object.keys(row);

    if (!header && idx === 0) {
      thisRow.forEach(function (key, i) {
        var value = key || (key === 0 ? 0 : '');
        csv += (0, _appendElement.appendElement)(value, thisRow.length, i, separator);
      });
    }

    thisRow.forEach(function (key, i) {
      var value = row[key] || (row[key] === 0 ? 0 : '');
      csv += (0, _appendElement.appendElement)(value, thisRow.length, i, separator);
    });
  });
  return csv;
};

exports.convertArrayOfObjectsToCSV = convertArrayOfObjectsToCSV;